"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    key: 0,
    class: "h-container__header"
};
var _hoisted_2 = {
    key: 1,
    class: "h-container__header_line"
};
var _hoisted_3 = { class: "h-container__content" };
var _hoisted_4 = {
    key: 0,
    class: "h-container__content_table-wrapper"
};
var _hoisted_5 = {
    key: 1,
    class: "h-container__footer"
};
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    props: {
        title: {},
        isBack: { type: Boolean, default: false },
        isTable: { type: Boolean, default: false },
        frameless: { type: Boolean, default: false },
        backFn: {}
    },
    setup: function (__props) {
        var router = (0, vue_router_1.useRouter)();
        var solts = (0, vue_3.useSlots)();
        var props = __props;
        /**
         * @description 返回
         */
        var back = function () {
            if (props.backFn && props.backFn instanceof Function) {
                props.backFn();
            }
            else {
                router.back();
            }
        };
        return function (_ctx, _cache) {
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["h-container", { 'frameless': _ctx.frameless }])
            }, [
                ((_ctx.$slots.header || _ctx.isBack || _ctx.title) && !_ctx.frameless)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (_ctx.$slots.header)
                            ? (0, vue_2.renderSlot)(_ctx.$slots, "header", { key: 0 })
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                (_ctx.isBack)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        class: "h-container__header_back",
                                        onClick: back
                                    }, [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            type: "primary",
                                            link: ""
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return _cache[0] || (_cache[0] = [
                                                (0, vue_2.createElementVNode)("span", { class: "iconfont icon-zuojiantou_huaban" }, null, -1),
                                                (0, vue_2.createTextVNode)("返回")
                                            ]); }),
                                            _: 1
                                        })
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (_ctx.isBack && _ctx.title)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (_ctx.title)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 2,
                                        class: "h-container__header_title",
                                        style: (0, vue_2.normalizeStyle)(!_ctx.isBack ? 'font-weight: 600' : '')
                                    }, (0, vue_2.toDisplayString)(_ctx.title), 5))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.renderSlot)(_ctx.$slots, "extra-header")
                            ], 64))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (_ctx.isTable)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "default")
                        ]))
                        : (0, vue_2.renderSlot)(_ctx.$slots, "default", { key: 1 })
                ]),
                (_ctx.$slots.footer)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                        (0, vue_2.renderSlot)(_ctx.$slots, "footer")
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 2));
        };
    }
});
